<template>
    <span>{{ formattedPhone }}</span>
</template>


<script>
    import IMask from 'imask';

    export default {
        name: 'formatted-phone',
        props: ['phone', 'masks'],
        data() {
            return {
            }
        },
        computed: {
            formattedPhone() {
                return this.formatPhone(this.phone);
            }
        },
        methods: {
            formatPhone(phone) {
              /*  console.log('phone',phone);
                console.log('this.masks',this.masks);*/
                if(this.masks!==undefined){
                    const masks = (Array.isArray(this.masks.v_mask_phone) ? this.masks.v_mask_phone : [this.masks.v_mask_phone]).map(function (mask) {
                        return {
                            mask,
                            definitions: {
                                '#': /[0-9]/
                            }
                        };
                    });
                    return IMask.pipe(phone.trim(), {
                        mask: masks,
                    })
                }
            }
        }
    }
</script>
